<template>
	<div class="form-floating">
		<select class="form-select" v-model.trim="selectedSchedule" id="selectedSchedule">
			<option
				v-for="sched in getAllSchedules"
				:key="sched.id"
				:value="{ schedule: sched.schedule, season: sched.season }"
			>
				{{ sched.season }}
			</option>
		</select>
		<label for="floatingSelectGridL">Choose a schedule</label>
	</div>
	<div v-if="selectedSchedule" class="form-floating mt-3 mb-5">
		<select class="form-select" v-model.trim="selectedGame" id="selectedSchedule">
			<option>Week # - Home vs Away</option>
			<option v-for="game of teamGames" :key="game.week" :value="game">
				Week {{ game.week }} - {{ game.home }} vs {{ game.away }}
			</option>
		</select>
		<label for="floatingSelectGridL">Choose a game</label>
	</div>
	<small class="text-start text-white mb-0 mt-5">On desktop, hover over players name for more info</small>
	<div class="text-info">
		<div class="row">
			<div class="col pe-0" style="background-color: #263238">
				<h6 class="mt-3 mb-3 border-bottom text-start">Players</h6>
				<draggable
					class="ps-0"
					:list="players"
					item-key="lastName"
					tag="transition-group"
					v-bind="dragOptions"
					handle=".handle"
					:move="handleMovePla"
					@end="handleDragEndPla"
					:component-data="{ tag: 'ul', name: 'flip-list', type: 'transition' }"
				>
					<template #item="{ element }">
						<div role="button" class="pb-2 pt-2 border-bottom handle">
							<i role="button" class="fa fa-align-justify float-start"></i>
							<div
								data-bs-toggle="tooltip"
								data-bs-placement="top"
								:title="
									element.positions +
									' --- ' +
									(
										(element.stats.singles +
											element.stats.doubles +
											element.stats.triples +
											element.stats.homeruns) /
										element.stats.atBats
									).toFixed(3) +
									'/' +
									(
										(element.stats.singles +
											element.stats.doubles +
											element.stats.triples +
											element.stats.homeruns +
											element.stats.walks +
											element.stats.hbp) /
										(element.stats.atBats +
											element.stats.walks +
											element.stats.hbp +
											element.stats.sf)
									).toFixed(3) +
									'/' +
									(
										(element.stats.singles +
											2 * element.stats.doubles +
											3 * element.stats.triples +
											4 * element.stats.homeruns) /
										element.stats.atBats
									).toFixed(3)
								"
							>
								{{ element.firstName }} {{ element.lastName.charAt(0) }}.
							</div>
						</div>
					</template>
				</draggable>
			</div>
			<div class="col ps-0" style="background-color: #263238">
				<h6 class="mt-3 mb-3 text-start border-bottom">Position</h6>
				<draggable
					:list="positions"
					item-key="order"
					tag="transition-group"
					v-bind="dragOptions"
					handle=".handle"
					:move="handleMovePos"
					@end="handleDragEndPos"
					:component-data="{ tag: 'ul', name: 'flip-list', type: 'transition', class: 'ps-0' }"
				>
					<template #item="{ element }">
						<div class="pb-2 pt-2 text-start border-bottom ps-0">
							<i role="button" class="fa fa-align-justify handle float-start me-3 ps-0"></i>
							{{ element.pos }}
						</div>
					</template>
				</draggable>
			</div>
		</div>
	</div>
	<button @click="saveLineUp" class="btn btn-outline-info mt-4">Save</button>
</template>

<script>
import draggable from 'vuedraggable';
export default {
	components: {
		draggable
	},
	emits: ['load-lineups','close'],
	props: ['getAllSchedules', 'getUsers','getUserTeam','getLineUp','getTeamId'],
	data() {
		return {
			players: this.getUsers,
			positions: [
				{
					pos: 'P',
					order: 1,
				},
				{
					pos: 'C',
					order: 2,
				},
				{
					pos: '1B',
					order: 3,
				},
				{
					pos: '2B',
					order: 4,
				},
				{
					pos: '3B',
					order: 5,
				},
				{
					pos: 'SS',
					order: 6,
				},
				{
					pos: 'LF',
					order: 7,
				},
				{
					pos: 'CF',
					order: 8,
				},
				{
					pos: 'RF',
					order: 9,
				},
				{
					pos: 'Bench',
					order: 10,
				},
				{
					pos: 'Bench',
					order: 11,
				},
				{
					pos: 'Bench',
					order: 12,
				},
				{
					pos: 'Bench',
					order: 13,
				},
				{
					pos: 'Bench',
					order: 14,
				},
				{
					pos: 'Bench',
					order: 15,
				},
			],
			selectedSchedule: null,
			selectedGame: null,
			teamGames: [],
		}
	},
	created() {
		this.loadUsers()
	},
	watch: {
		selectedSchedule() {
			this.lineUpGame();
		},
	},
	computed: {
		dragOptions() {
			return {
				animation: 0,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
	},
	methods: {
		async saveLineUp() {
			const payload = {
				battingOrder: this.players,
				positionOrder: this.positions,
				teamId: this.getTeamId,
				season: this.selectedSchedule,
				game: this.selectedGame,
			};
			try {
				await this.$store.dispatch('teams/addNewLineUp', payload);
				this.showSetLineUp = false;
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			setTimeout(() => {
				this.$emit('load-lineups')
				this.$emit('close')
			}, 500);
		},
		lineUpGame() {
			const schedule = this.selectedSchedule.schedule;
			const filtered = schedule.filter(
				(team) => team.home === this.getUserTeam || team.away === this.getUserTeam
			);
			const allLineUps = this.getLineUp;
			const noLineup = [];
			const withLineup = [];
			for (let i = 0; i < filtered.length; i++) {
				var found = false;
				for (let j = 0; j < allLineUps.length; j++) {
					if (
						filtered[i].home === allLineUps[j].game.home &&
						filtered[i].away === allLineUps[j].game.away &&
						filtered[i].week === allLineUps[j].game.week
					) {
						found = true;
					}
				}
				if (!found) {
					noLineup.push(filtered[i]);
				} else {
					withLineup.push(filtered[i]);
				}
			}
			this.gamesWithLineUps = withLineup;
			this.teamGames = noLineup;
		},
		handleDragEndPos() {
			this.futureItem = this.positions[this.futureIndex];
			this.movingItem = this.positions[this.movingIndex];
			const _positions = Object.assign([], this.positions);
			_positions[this.futureIndex] = this.movingItem;
			_positions[this.movingIndex] = this.futureItem;

			this.positions = _positions;
		},
		handleMovePos(e) {
			const { index, futureIndex } = e.draggedContext;
			this.movingIndex = index;
			this.futureIndex = futureIndex;
			return false; // disable sort
		},
		handleDragEndPla() {
			this.futureItem = this.players[this.futureIndex];
			this.movingItem = this.players[this.movingIndex];
			const _players = Object.assign([], this.players);
			_players[this.futureIndex] = this.movingItem;
			_players[this.movingIndex] = this.futureItem;

			this.players = _players;
		},
		handleMovePla(e) {
			const { index, futureIndex } = e.draggedContext;
			this.movingIndex = index;
			this.futureIndex = futureIndex;
			return false; // disable sort
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
	}
}
</script>